import { sendGet } from "./generic"

export const getCoverageLimits = ()=>{
    return sendGet("Coverages/CoverageLimits")
}